/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProfileUpdateRequest } from './profile-update-request';

export interface PatchedDeckUserProfileRequest {
  first_name?: string;
  last_name?: string;
  profile?: ProfileUpdateRequest;
}
